(function() {
  var SCHEDULE_INFO_BASE = window.BLOOD_SCHEDULE_INFO_BASE_URL || 'https://huq7rhg850.execute-api.ap-south-1.amazonaws.com/PROD_V1/webhook/wellbeing';
  var loaderEl = document.getElementById('blood-slot-booking-loader');
  var containerEl = document.getElementById('blood-slot-booking-container');
  var SCHEDULE_INFO_API_KEY = window.BLOOD_SCHEDULE_INFO_API_KEY || '6IcF21h3dj2krTVC2Imfvay5GmajpbCS4jP5iXiK';

  function showContainer() {
    if (loaderEl) loaderEl.style.display = 'none';
    if (containerEl) containerEl.style.display = '';
  }

  function getUrlParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name) || '';
  }
  function getCustomerIdForScheduleInfo() {
    var fromUrl = getUrlParam('customer_id');
    if (fromUrl) return fromUrl.trim();
    try {
      var fromStorage = localStorage.getItem('kp_customer_id');
      return fromStorage ? String(fromStorage).trim() : '';
    } catch (e) { return ''; }
  }
  var customerId = getCustomerIdForScheduleInfo();
  if (!customerId) {
    showContainer();
    return;
  }
  fetch(SCHEDULE_INFO_BASE + '/' + encodeURIComponent(customerId) + '/scheduleInfo', {
    credentials: 'omit',
    headers: {
      'X-API-KEY': SCHEDULE_INFO_API_KEY
    }
  })
    .then(function(res) { return res.ok ? res.json() : Promise.reject(); })
    .then(function(data) {
      if (!data) { showContainer(); return; }
      var alreadyBookedEl = document.querySelector('.blood-slot-booking-already-booked-container');
      var formContainer = document.querySelector('.blood-slot-booking-form-container');
      var submitContainer = document.querySelector('.blood-slot-booking-submit-container');
      var bloodSlotBookingHeaderTitle = document.querySelector('.blood-slot-booking-header-title');
      var bloodSlotBookingHeaderDescription = document.querySelector('.blood-slot-booking-header-description');
      var alreadyBookedCustomerId = document.querySelector('#already-booked-customer-id span');
      var alreadyBookedBookingDate = document.querySelector('#already-booked-booking-date span');
      var alreadyBookedBookingDay = document.querySelector('#already-booked-booking-day span');
      var alreadyBookedTime = document.querySelector('#already-booked-time span');
      var alreadyBookedOrderId = document.querySelector('#already-booked-order-id span');
      var alreadyBookedIdMode = window.BLOOD_BOOKING_ALREADY_BOOKED_IDENTIFIER || 'order_id';
      var showOrderId = alreadyBookedIdMode === 'order_id';

      if (data.paymentStatus !== 'PAID') {
        if (formContainer) formContainer.style.display = 'block';
        if (bloodSlotBookingHeaderTitle) bloodSlotBookingHeaderTitle.style.display = '';
        if (bloodSlotBookingHeaderDescription) bloodSlotBookingHeaderDescription.style.display = '';
        if (alreadyBookedEl) alreadyBookedEl.style.display = 'none';
        showContainer();
        return;
      }

      var scheduleInfo = data.scheduleInfo;
      if (scheduleInfo == null || scheduleInfo === false || scheduleInfo === '') { showContainer(); return; }
      if (alreadyBookedEl) alreadyBookedEl.style.display = 'block';

      var successContainerEl = document.querySelector('.blood-slot-booking-success-container');
      if (successContainerEl) successContainerEl.style.display = 'none';
      if (formContainer) formContainer.style.display = 'none';
      if (submitContainer) submitContainer.style.display = 'none';
      if (bloodSlotBookingHeaderTitle) bloodSlotBookingHeaderTitle.style.display = 'none';
      if (bloodSlotBookingHeaderDescription) bloodSlotBookingHeaderDescription.style.display = 'none';
      if (alreadyBookedCustomerId && alreadyBookedCustomerId.parentElement) {
        alreadyBookedCustomerId.parentElement.style.display = showOrderId ? 'none' : '';
        alreadyBookedCustomerId.textContent = data.customerId || '';
      }
      if (alreadyBookedOrderId && alreadyBookedOrderId.parentElement) {
        var scheduleOrderId = (data && (data.orderId || data.order_id || (data.scheduleInfo && (data.scheduleInfo.orderId || data.scheduleInfo.order_id)))) || data.customerId || '';
        alreadyBookedOrderId.parentElement.style.display = showOrderId ? '' : 'none';
        alreadyBookedOrderId.textContent = scheduleOrderId;
      }
      if (alreadyBookedBookingDay) {
        alreadyBookedBookingDay.textContent = data.scheduleInfo.day;
      }
      if (alreadyBookedBookingDate) {
        const date = new Date(data.scheduleInfo.date);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();  
        alreadyBookedBookingDate.textContent = `${day}-${month}-${year}`;
      }
      if (alreadyBookedTime && data.scheduleInfo.time) {
        alreadyBookedTime.textContent = data.scheduleInfo.time;
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('booking_success');
        url.searchParams.delete('blood_booking_success');
        window.history.replaceState({}, '', url.pathname + url.search);
      }
      showContainer();
    })
    .catch(function() {
      showContainer();
    });
})();

(function() {
  var dropdown = document.getElementById('blood-state-dropdown');
  if (!dropdown) return;
  var trigger = document.getElementById('blood-state-trigger');
  var triggerText = dropdown.querySelector('.custom-dropdown__trigger-text');
  var select = document.getElementById('blood-state');
  var list = document.getElementById('blood-state-list');
  var options = list.querySelectorAll('.custom-dropdown__option');

  function open() {
    dropdown.classList.add('is-open');
    dropdown.setAttribute('aria-expanded', 'true');
  }
  function close() {
    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-expanded', 'false');
  }
  function selectOption(value, text) {
    select.value = value;
    triggerText.textContent = text;
    if (value) {
      trigger.classList.remove('custom-dropdown__trigger--placeholder');
    } else {
      trigger.classList.add('custom-dropdown__trigger--placeholder');
    }
    options.forEach(function(opt) {
      opt.classList.toggle('is-selected', opt.getAttribute('data-value') === value);
    });
    close();
    try { select.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }

  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    if (dropdown.classList.contains('is-open')) close();
    else open();
  });

  options.forEach(function(opt) {
    opt.addEventListener('click', function() {
      selectOption(opt.getAttribute('data-value'), opt.textContent.trim());
    });
  });

  document.addEventListener('click', function(e) {
    if (dropdown.classList.contains('is-open') && !dropdown.contains(e.target)) close();
  });

  select.addEventListener('change', function() {
    var opt = list.querySelector('[data-value="' + select.value.replace(/"/g, '\\"') + '"]');
    if (opt) {
      triggerText.textContent = opt.textContent.trim();
      trigger.classList.toggle('custom-dropdown__trigger--placeholder', !select.value);
      options.forEach(function(o) {
        o.classList.toggle('is-selected', o.getAttribute('data-value') === select.value);
      });
    }
  });
})();

(function() {
  var timeDropdown = document.getElementById('blood-time-dropdown');
  if (!timeDropdown) return;
  var timeTrigger = document.getElementById('blood-time-trigger');
  var timeTriggerText = timeDropdown.querySelector('.custom-time-dropdown__trigger-text');
  var timeInput = document.getElementById('blood-time');
  var timeList = document.getElementById('blood-time-list');
  var timeOptions = timeList.querySelectorAll('.custom-time-dropdown__option');

  function open() {
    timeDropdown.classList.add('is-open');
    timeDropdown.setAttribute('aria-expanded', 'true');
  }
  function close() {
    timeDropdown.classList.remove('is-open');
    timeDropdown.setAttribute('aria-expanded', 'false');
  }
  function selectSlot(value) {
    timeInput.value = value;
    timeTriggerText.textContent = value;
    if (value) {
      timeTrigger.classList.remove('custom-time-dropdown__trigger--placeholder');
    } else {
      timeTrigger.classList.add('custom-time-dropdown__trigger--placeholder');
    }
    timeOptions.forEach(function(opt) {
      opt.classList.toggle('is-selected', opt.getAttribute('data-value') === value);
    });
    close();
    try { timeInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
    try { timeInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }

  timeTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    if (timeDropdown.classList.contains('is-open')) close();
    else open();
  });
  timeOptions.forEach(function(opt) {
    opt.addEventListener('click', function() {
      selectSlot(opt.getAttribute('data-value'));
    });
  });
  document.addEventListener('click', function(e) {
    if (timeDropdown.classList.contains('is-open') && !timeDropdown.contains(e.target)) close();
  });
})();

(function() {
  var picker = document.getElementById('blood-date-picker');
  if (!picker) return;
  var trigger = document.getElementById('blood-date-trigger');
  var triggerText = picker.querySelector('.custom-date-picker__trigger-text');
  var input = document.getElementById('blood-date');
  var calendar = document.getElementById('blood-date-calendar');
  var monthYearEl = document.getElementById('blood-date-month-year');
  var daysEl = document.getElementById('blood-date-days');
  var prevBtn = document.getElementById('blood-date-prev');
  var nextBtn = document.getElementById('blood-date-next');

  // Before 10 AM: can book from next day. From 10 AM onward: from day after next.
  var now = new Date();
  var minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (now.getHours() < 10) {
    minDate.setDate(minDate.getDate() + 1);
  } else {
    minDate.setDate(minDate.getDate() + 2);
  }
  minDate.setHours(0, 0, 0, 0);

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var currentView = new Date(minDate);
  currentView.setDate(1);

  function formatDisplay(d) {
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return day + '-' + month + '-' + year;
  }
  function formatValue(d) {
    var y = d.getFullYear();
    var m = (d.getMonth() + 1);
    var day = d.getDate();
    return y + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  function isBefore(a, b) {
    a.setHours(0,0,0,0);
    b.setHours(0,0,0,0);
    return a.getTime() < b.getTime();
  }
  function isSameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function open() { picker.classList.add('is-open'); }
  function close() { picker.classList.remove('is-open'); }
  function selectDate(date) {
    input.value = formatValue(date);
    triggerText.textContent = formatDisplay(date);
    trigger.classList.remove('custom-date-picker__trigger--placeholder');
    render();
    close();
    try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
    try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    if (window.bloodBookingFilterTimeSlots) {
      window.bloodBookingFilterTimeSlots(formatValue(date));
    }
  }

  function render() {
    var year = currentView.getFullYear();
    var month = currentView.getMonth();
    monthYearEl.textContent = MONTHS[month] + ' ' + year;

    var first = new Date(year, month, 1);
    var last = new Date(year, month + 1, 0);
    var startDay = first.getDay();
    var daysInMonth = last.getDate();
    var selectedDate = input.value ? new Date(input.value + 'T00:00:00') : null;

    var html = '';
    for (var i = 0; i < startDay; i++) {
      html += '<button type="button" class="custom-date-picker__day is-empty" disabled></button>';
    }
    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(year, month, d);
      var disabled = isBefore(date, minDate);
      var selected = selectedDate && isSameDay(date, selectedDate);
      var cls = 'custom-date-picker__day';
      if (disabled) cls += ' is-disabled';
      if (selected) cls += ' is-selected';
      var value = formatValue(date);
      html += '<button type="button" class="' + cls + '" data-date="' + value + '" ' + (disabled ? 'disabled' : '') + '>' + d + '</button>';
    }
    daysEl.innerHTML = html;

    daysEl.querySelectorAll('.custom-date-picker__day:not(.is-empty):not(.is-disabled)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectDate(new Date(btn.getAttribute('data-date') + 'T00:00:00'));
      });
    });
  }

  prevBtn.addEventListener('click', function() {
    currentView.setMonth(currentView.getMonth() - 1);
    render();
  });
  nextBtn.addEventListener('click', function() {
    currentView.setMonth(currentView.getMonth() + 1);
    render();
  });
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    if (picker.classList.contains('is-open')) close();
    else {
      if (input.value) {
        var d = new Date(input.value + 'T00:00:00');
        currentView.setFullYear(d.getFullYear());
        currentView.setMonth(d.getMonth());
      } else {
        currentView.setFullYear(minDate.getFullYear());
        currentView.setMonth(minDate.getMonth());
      }
      currentView.setDate(1);
      open();
      render();
    }
  });
  document.addEventListener('click', function(e) {
    if (picker.classList.contains('is-open') && !picker.contains(e.target)) close();
  });

  if (input.value) {
    var d = new Date(input.value + 'T00:00:00');
    currentView.setFullYear(d.getFullYear());
    currentView.setMonth(d.getMonth());
    currentView.setDate(1);
  }
  render();
})();

(function() {
  var pincodeInput = document.getElementById('blood-pincode');
  if (!pincodeInput) return;

  var form = pincodeInput.form;
  var errorEl = document.getElementById('blood-pincode-error');
  var serviceablePincodes = null;
  var SERVICEABLE_PINCODES_URL = window.BLOOD_SERVICEABLE_PINCODES_URL || '';

  // Load serviceable pincodes list once
  try {
    fetch(SERVICEABLE_PINCODES_URL, { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) throw new Error('Failed to load pincodes');
        return res.json();
      })
      .then(function(data) {
        serviceablePincodes = Array.isArray(data) ? data : null;
      })
      .catch(function() {
        serviceablePincodes = null;
      });
  } catch (e) {
    serviceablePincodes = null;
  }

  function clearError() {
    pincodeInput.setCustomValidity('');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function showError(message) {
    pincodeInput.setCustomValidity(message || '');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = message ? 'block' : 'none';
    }
  }

  function validatePincode() {
    clearError();

    var value = (pincodeInput.value || '').trim();
    if (!value) {
      return true; // let required+browser handle empty
    }

    // Exactly 6 digits, cannot start with 0
    if (!/^[1-9][0-9]{5}$/.test(value)) {
      showError('Please enter a valid 6-digit pincode that does not start with 0.');
      return false;
    }

    // If list failed to load, skip serviceability check (do not block)
    if (!Array.isArray(serviceablePincodes)) {
      return true;
    }

    var isServiceable = serviceablePincodes.indexOf(value) !== -1;
    if (!isServiceable) {
      showError('We currently do not service this pincode.');
      return false;
    }

    clearError();
    return true;
  }

  pincodeInput.addEventListener('input', function() {
    var value = pincodeInput.value || '';

    // Allow only digits, trim anything else the user types (no spaces, letters, symbols)
    var digitsOnly = value.replace(/\D/g, '');

    // Enforce max length 6
    if (digitsOnly.length > 6) {
      digitsOnly = digitsOnly.slice(0, 6);
    }

    if (digitsOnly !== value) {
      var diff = value.length - digitsOnly.length;
      var pos = pincodeInput.selectionStart || digitsOnly.length;
      pincodeInput.value = digitsOnly;
      try {
        pincodeInput.setSelectionRange(pos - diff, pos - diff);
      } catch (e) {}
    }

    clearError();
  });

  pincodeInput.addEventListener('blur', function() {
    validatePincode();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      if (!validatePincode()) {
        e.preventDefault();
        pincodeInput.reportValidity();
      }
    });
  }

  // Expose for global form validation
  window.bloodBookingValidatePincode = validatePincode;
})();

(function() {
  var addressInput = document.getElementById('blood-address');
  if (!addressInput) return;

  var form = addressInput.form;
  var errorEl = document.getElementById('blood-address-error');

  function clearError() {
    addressInput.setCustomValidity('');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function showError(message) {
    addressInput.setCustomValidity(message || '');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = message ? 'block' : 'none';
    }
  }

  function validateAddress() {
    clearError();

    var value = (addressInput.value || '').trim();
    if (!value) {
      // Let "required" handle empty value
      return true;
    }

    if (value.length < 5 || value.length > 250) {
      showError('Address must be between 5 and 250 characters.');
      return false;
    }

    // Allowed characters: letters, numbers, space, comma, period, hyphen, slash, hash
    var allowedPattern = /^[A-Za-z0-9 ,.\-/#]+$/;
    if (!allowedPattern.test(value)) {
      showError('Please use only letters, numbers, spaces, and , . - / # in the address.');
      return false;
    }

    clearError();
    return true;
  }

  addressInput.addEventListener('input', function() {
    // Strip disallowed characters as the user types
    var value = addressInput.value || '';
    var sanitized = value.replace(/[^A-Za-z0-9 ,.\-/#]/g, '');
    if (sanitized !== value) {
      var pos = addressInput.selectionStart || sanitized.length;
      addressInput.value = sanitized;
      try {
        addressInput.setSelectionRange(pos - (value.length - sanitized.length), pos - (value.length - sanitized.length));
      } catch (e) {}
    }
    clearError();
  });

  addressInput.addEventListener('blur', function() {
    validateAddress();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      if (!validateAddress()) {
        e.preventDefault();
        addressInput.reportValidity();
      }
    });
  }

  // Expose for global form validation
  window.bloodBookingValidateAddress = validateAddress;
})();

(function() {
  var flatInput = document.getElementById('blood-flat');
  if (!flatInput) return;

  var form = flatInput.form;
  var errorEl = document.getElementById('blood-flat-error');

  function clearError() {
    flatInput.setCustomValidity('');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function showError(message) {
    flatInput.setCustomValidity(message || '');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = message ? 'block' : 'none';
    }
  }

  function validateFlat() {
    clearError();
    var value = (flatInput.value || '').trim();
    if (!value) {
      // Don't show error on load—only invalid. Browser will show "Please fill out this field" on submit.
      return false;
    }
    if (value.length < 2 || value.length > 100) {
      showError('Flat must be between 2 and 100 characters.');
      return false;
    }
    var allowedPattern = /^[A-Za-z0-9 ,.\-/#]+$/;
    if (!allowedPattern.test(value)) {
      showError('Use only letters, numbers, spaces, and , . - / #');
      return false;
    }
    clearError();
    return true;
  }

  flatInput.addEventListener('input', function() {
    var value = flatInput.value || '';
    var sanitized = value.replace(/[^A-Za-z0-9 ,.\-/#]/g, '');
    if (sanitized !== value) {
      flatInput.value = sanitized;
    }
    clearError();
  });

  flatInput.addEventListener('blur', function() {
    validateFlat();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      if (!validateFlat()) {
        e.preventDefault();
        flatInput.reportValidity();
      }
    });
  }

  window.bloodBookingValidateFlat = validateFlat;
})();

(function() {
  var landmarkInput = document.getElementById('blood-landmark');
  if (!landmarkInput) return;

  var form = landmarkInput.form;
  var errorEl = document.getElementById('blood-landmark-error');

  function clearError() {
    landmarkInput.setCustomValidity('');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function showError(message) {
    landmarkInput.setCustomValidity(message || '');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = message ? 'block' : 'none';
    }
  }

  function validateLandmark() {
    clearError();
    var value = (landmarkInput.value || '').trim();
    if (!value) return true;
    if (value.length > 150) {
      showError('Landmark must be at most 150 characters.');
      return false;
    }
    var allowedPattern = /^[A-Za-z0-9 ,.\-/#]+$/;
    if (!allowedPattern.test(value)) {
      showError('Use only letters, numbers, spaces, and , . - / #');
      return false;
    }
    clearError();
    return true;
  }

  landmarkInput.addEventListener('input', function() {
    var value = landmarkInput.value || '';
    var sanitized = value.replace(/[^A-Za-z0-9 ,.\-/#]/g, '');
    if (sanitized !== value) {
      landmarkInput.value = sanitized;
    }
    clearError();
  });

  landmarkInput.addEventListener('blur', function() {
    validateLandmark();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      if (!validateLandmark()) {
        e.preventDefault();
        landmarkInput.reportValidity();
      }
    });
  }

  window.bloodBookingValidateLandmark = validateLandmark;
})();

(function() {
  var emailInput = document.getElementById('blood-email');
  if (!emailInput) return;

  var form = emailInput.form;
  var errorEl = document.getElementById('blood-email-error');

  function clearError() {
    emailInput.setCustomValidity('');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function showError(message) {
    emailInput.setCustomValidity(message || '');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = message ? 'block' : 'none';
    }
  }

  function validateEmail() {
    clearError();

    var value = (emailInput.value || '').trim();
    if (!value) {
      // Let "required" handle empty value
      return true;
    }

    // Basic email pattern, leaves deeper checks to backend if needed
    var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!pattern.test(value)) {
      showError('Please enter a valid email address.');
      return false;
    }

    clearError();
    return true;
  }

  emailInput.addEventListener('input', function() {
    clearError();
  });

  emailInput.addEventListener('blur', function() {
    validateEmail();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      if (!validateEmail()) {
        e.preventDefault();
        emailInput.reportValidity();
      }
    });
  }

  // Expose for global form validation
  window.bloodBookingValidateEmail = validateEmail;
})();

(function() {
  var cityInput = document.getElementById('blood-city');
  if (!cityInput) return;

  var form = cityInput.form;
  var errorEl = document.getElementById('blood-city-error');

  function clearError() {
    cityInput.setCustomValidity('');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function showError(message) {
    cityInput.setCustomValidity(message || '');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = message ? 'block' : 'none';
    }
  }

  function validateCity() {
    clearError();

    var value = (cityInput.value || '').trim();
    if (!value) {
      // Let "required" handle empty value
      return true;
    }

    // Allowed: letters, space, dot, hyphen
    var allowedPattern = /^[A-Za-z .-]+$/;
    if (!allowedPattern.test(value)) {
      showError('Please use only letters, spaces, dots (.) and hyphens (-) in the city name.');
      return false;
    }

    clearError();
    return true;
  }

  cityInput.addEventListener('input', function() {
    // Strip disallowed characters as the user types
    var value = cityInput.value || '';
    var sanitized = value.replace(/[^A-Za-z .-]/g, '');
    if (sanitized !== value) {
      var diff = value.length - sanitized.length;
      var pos = cityInput.selectionStart || sanitized.length;
      cityInput.value = sanitized;
      try {
        cityInput.setSelectionRange(pos - diff, pos - diff);
      } catch (e) {}
    }
    clearError();
  });

  cityInput.addEventListener('blur', function() {
    validateCity();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      if (!validateCity()) {
        e.preventDefault();
        cityInput.reportValidity();
      }
    });
  }

  window.bloodBookingValidateCity = validateCity;
})();

(function() {
  var ALL_SLOTS = ['am_6_7','am_7_8','am_8_9','am_9_10','am_10_11','am_11_12','pm_12_1','pm_1_2','pm_2_3','pm_3_4','pm_4_5','pm_5_6','pm_6_7','pm_7_8','pm_8_9'];

  function parseDaySlots(str) {
    if (!str || typeof str !== 'string') return null;
    return str.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
  }

  function getSlotsForDay(dayIndex) {
    var config = window.BLOOD_BOOKING_DAY_SLOTS;
    if (!config || !config[String(dayIndex)]) return ALL_SLOTS;
    var parsed = parseDaySlots(config[String(dayIndex)]);
    return parsed && parsed.length > 0 ? parsed : ALL_SLOTS;
  }

  function filterTimeSlotsForDate(dateString) {
    var list = document.getElementById('blood-time-list');
    if (!list || !dateString) return;
    var d = new Date(dateString + 'T00:00:00');
    if (isNaN(d.getTime())) return;
    var dayIndex = d.getDay();
    var allowedKeys = getSlotsForDay(dayIndex);
    var options = list.querySelectorAll('.custom-time-dropdown__option');
    var visibleValues = [];
    options.forEach(function(opt) {
      var key = opt.getAttribute('data-slot-key');
      var shouldShow = !key || allowedKeys.indexOf(key) !== -1;
      opt.style.display = shouldShow ? '' : 'none';
      if (shouldShow) visibleValues.push(opt.getAttribute('data-value'));
      else opt.classList.remove('is-selected');
    });
    var timeInput = document.getElementById('blood-time');
    var trigger = document.getElementById('blood-time-trigger');
    var triggerText = document.querySelector('#blood-time-dropdown .custom-time-dropdown__trigger-text');
    if (timeInput && visibleValues.indexOf(timeInput.value) === -1) {
      timeInput.value = '';
      if (triggerText) triggerText.textContent = '';
      if (trigger) trigger.classList.add('custom-time-dropdown__trigger--placeholder');
      try { timeInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
    }
  }

  window.bloodBookingFilterTimeSlots = filterTimeSlotsForDate;
  var dateInput = document.getElementById('blood-date');
  if (dateInput && dateInput.value) filterTimeSlotsForDate(dateInput.value);
})();

(function() {
  var form = document.querySelector('.blood-slot-booking-form');
  var submitButton = document.querySelector('.blood-slot-booking-submit-button');
  var dateInput = document.getElementById('blood-date');
  var timeInput = document.getElementById('blood-time');
  if (!form || !submitButton) return;

  function updateSubmitState() {
    if (window.bloodBookingValidateEmail) {
      window.bloodBookingValidateEmail();
    }
    if (window.bloodBookingValidateAddress) {
      window.bloodBookingValidateAddress();
    }
    if (window.bloodBookingValidateFlat) {
      window.bloodBookingValidateFlat();
    }
    if (window.bloodBookingValidateLandmark) {
      window.bloodBookingValidateLandmark();
    }
    if (window.bloodBookingValidateCity) {
      window.bloodBookingValidateCity();
    }
    if (window.bloodBookingValidatePincode) {
      window.bloodBookingValidatePincode();
    }

    var addressEl = document.getElementById('blood-address');
    var flatEl = document.getElementById('blood-flat');
    var emailEl = document.getElementById('blood-email');
    var cityEl = document.getElementById('blood-city');
    var stateEl = document.getElementById('blood-state');
    var pincodeEl = document.getElementById('blood-pincode');

    var allRequiredFilled =
      (addressEl && (addressEl.value || '').trim().length > 0) &&
      (flatEl && (flatEl.value || '').trim().length > 0) &&
      (emailEl && (emailEl.value || '').trim().length > 0) &&
      (cityEl && (cityEl.value || '').trim().length > 0) &&
      (stateEl && (stateEl.value || '').trim().length > 0) &&
      (pincodeEl && (pincodeEl.value || '').trim().length >= 6) &&
      (dateInput && (dateInput.value || '').length > 0) &&
      (timeInput && (timeInput.value || '').length > 0);

    var isValid = form.checkValidity() && allRequiredFilled;

    submitButton.disabled = !isValid;
  }

  function restoreSubmitButtonFromCartClose() {
    if (submitButton.textContent === 'Scheduling...') {
      submitButton.textContent = 'Confirm Appointment';
      updateSubmitState();
    }
  }
  window.bloodBookingRestoreSubmitButton = restoreSubmitButtonFromCartClose;

  form.addEventListener('input', updateSubmitState);
  form.addEventListener('change', updateSubmitState);

  // Initial state on load
  updateSubmitState();

  // Schedule API: on button click (no form submit = no page reload), validate then POST
  submitButton.addEventListener('click', function() {
    if (submitButton.disabled) return;

    if (window.bloodBookingValidateEmail && !window.bloodBookingValidateEmail()) return;
    if (window.bloodBookingValidateAddress && !window.bloodBookingValidateAddress()) return;
    if (window.bloodBookingValidateFlat && !window.bloodBookingValidateFlat()) return;
    if (window.bloodBookingValidateLandmark && !window.bloodBookingValidateLandmark()) return;
    if (window.bloodBookingValidateCity && !window.bloodBookingValidateCity()) return;
    if (window.bloodBookingValidatePincode && !window.bloodBookingValidatePincode()) return;
    if (!dateInput || !dateInput.value || !timeInput || !timeInput.value) return;

    var apiErrorEl = document.getElementById('blood-schedule-api-error');
    if (apiErrorEl) { apiErrorEl.style.display = 'none'; apiErrorEl.textContent = ''; }

    var address = (document.getElementById('blood-address') && document.getElementById('blood-address').value) || '';
    var flatEl = document.getElementById('blood-flat');
    var landmarkEl = document.getElementById('blood-landmark');
    var emailEl = document.getElementById('blood-email');
    var flatFromInput = (flatEl && flatEl.value) ? flatEl.value.trim() : '';
    var landmarkFromInput = (landmarkEl && landmarkEl.value) ? landmarkEl.value.trim() : '';
    var emailFromInput = (emailEl && emailEl.value) ? emailEl.value.trim() : '';
    var city = (document.getElementById('blood-city') && document.getElementById('blood-city').value) || '';
    var stateEl = document.getElementById('blood-state');
    var state = (stateEl && stateEl.value) || '';
    var pincode = (document.getElementById('blood-pincode') && document.getElementById('blood-pincode').value) || '';
    var date = dateInput.value;
    var timeRaw = timeInput.value;
    (function() {
      var m = timeRaw.match(/^(AM|PM)\s+(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})$/i);
      if (m) { timeRaw = m[2] + ' ' + m[1].toUpperCase() + ' to ' + m[3] + ' ' + m[1].toUpperCase(); }
    })();

    

    function getUrlParam(name) {
      var params = new URLSearchParams(window.location.search);
      return params.get(name) || '';
    }
    var urlVariantId = getUrlParam('variant_id');
    var urlCustomerId = getUrlParam('customer_id');
    var variantId = urlVariantId;
    var productId = getUrlParam('product_id');
    var customerId = urlCustomerId;
    var baseUrl = window.WBN_API_BASE_URL || "https://apibackend.wollboingnutrition.shop";

    var payload = {
      productId: productId,
      customerId: customerId || 'guest',
      address: address.trim(),
      flat: flatFromInput,
      landmark: landmarkFromInput,
      emailAddress: emailFromInput,
      city: city.trim(),
      state: state.trim(),
      pincode: pincode.trim(),
      date: date,
      time: timeRaw
    };

    submitButton.disabled = true;
    submitButton.textContent = 'Scheduling...';

    // Schedule API is called after payment (in triggerResolutePaymentApi). Store pending and open cart.
    (function() {
        var appointmentLocation = [address, city, state, pincode].filter(Boolean).join(', ');
        var customerName = '';
        try {
          sessionStorage.setItem('resolute_payment_pending', JSON.stringify({
            productId: String(productId),
            customerId: String(customerId),
            baseUrl: baseUrl,
            appointmentDate: date,
            appointmentTime: timeRaw,
            appointmentLocation: appointmentLocation,
            customerEmail: emailFromInput,
            customerName: customerName,
            address: address.trim(),
            flat: flatFromInput,
            landmark: landmarkFromInput,
            city: city.trim(),
            state: state.trim(),
            pincode: pincode.trim()
          }));
        } catch (e) {}

        var cartRoot = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

        // Appointment data carried on the order as line-item attributes (used by both checkout paths).
        var lineItemAttributes = [
          { key: 'is-blood-slot',        value: 'true' },
          { key: '_productId',           value: String(productId || '') },
          { key: '_customerId',          value: String(customerId || '') },
          { key: '_appointmentDate',     value: date },
          { key: '_appointmentTime',     value: timeRaw },
          { key: '_address',             value: address.trim() },
          { key: '_flat',                value: flatFromInput },
          { key: '_landmark',            value: landmarkFromInput },
          { key: '_city',                value: city.trim() },
          { key: '_state',               value: state.trim() },
          { key: '_pincode',             value: pincode.trim() },
          { key: '_email',               value: emailFromInput }
        ];

        // --- Native checkout path via Storefront API cart creation ---
        if (window.BLOOD_SCHEDULE_CHECKOUT_REDIRECTION) {
          var storefrontToken = window.BLOOD_STOREFRONT_TOKEN || '';
          var apiVersion = window.BLOOD_STOREFRONT_API_VERSION || '2026-10';
          var shopDomain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.hostname;

          if (!storefrontToken || !variantId) {
            window.location.href = cartRoot + 'checkout';
            restoreSubmitButtonFromCartClose();
            return;
          }

          // Submit the Shopify contact form with all appointment data (fire-and-forget)
          var contactForm = document.querySelector('.blood-slot-booking-form');
          if (contactForm) {
            try {
              var formData = new FormData(contactForm);
              formData.append('contact[product_id]',           String(productId || ''));
              formData.append('contact[customer_id]',          String(customerId || ''));
              formData.append('contact[variant_id]',           String(variantId || ''));
              formData.append('contact[appointment_location]', appointmentLocation);
              fetch(contactForm.action || window.location.pathname, {
                method: 'POST',
                body: formData,
                redirect: 'manual'
              }).catch(function() {});
            } catch (e) {}
          }

          var cartCreateMutation = [
            'mutation cartCreate($input: CartInput!) {',
            '  cartCreate(input: $input) {',
            '    cart { id checkoutUrl }',
            '    userErrors { field message }',
            '  }',
            '}'
          ].join(' ');

          var address1 = [flatFromInput, address.trim()].filter(Boolean).join(', ');
          var cartInput = {
            lines: [{
              merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
              quantity: 1,
              attributes: lineItemAttributes
            }],
            buyerIdentity: {
              email: emailFromInput || undefined,
              countryCode: 'IN',
              deliveryAddressPreferences: [{
                deliveryAddress: {
                  address1: address1,
                  address2: landmarkFromInput || undefined,
                  city: city.trim(),
                  province: state.trim(),
                  zip: pincode.trim(),
                  country: 'IN'
                }
              }]
            }
          };

          fetch('https://' + shopDomain + '/api/' + apiVersion + '/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontToken
            },
            body: JSON.stringify({
              query: cartCreateMutation,
              variables: { input: cartInput }
            })
          })
          .then(function(res) { return res.json(); })
          .then(function(result) {
            var cart = result && result.data && result.data.cartCreate && result.data.cartCreate.cart;
            if (cart && cart.checkoutUrl) {
              window.location.href = cart.checkoutUrl;
            } else {
              window.location.href = cartRoot + 'checkout';
              restoreSubmitButtonFromCartClose();
            }
          })
          .catch(function() {
            window.location.href = cartRoot + 'checkout';
            restoreSubmitButtonFromCartClose();
          });
          return;
        }

        // --- GoKwik checkout path: clear cart, add product, open GoKwik ---
        function clearCouponForBloodBooking() {
          try {
            sessionStorage.removeItem('appliedCouponCode');
            sessionStorage.removeItem('appliedCouponSavings');
            if (window.history && window.history.replaceState) {
              var u = new URL(window.location.href);
              if (u.searchParams.has('discount')) {
                u.searchParams.delete('discount');
                window.history.replaceState({}, '', u.pathname + u.search);
              }
            }
          } catch (e) {}
        }

        function openCheckout() {
          clearCouponForBloodBooking();
          var attempts = 0;
          var maxAttempts = 20;
          var interval = setInterval(function() {
            attempts++;
            var goKwikReady = typeof GoKwikChat !== 'undefined' || window.KwikCheckout || typeof onCheckoutClick === 'function' || (typeof window.triggerGokwikCustomCheckout === 'function');
            if (goKwikReady) {
              clearInterval(interval);
              try { sessionStorage.removeItem('wbn_prefilled_cart_page'); sessionStorage.removeItem('wbn_prefilled_cart_active'); } catch (e) {}
              if (typeof window.triggerGokwikCustomCheckout === 'function') {
                window.triggerGokwikCustomCheckout();
              } else if (typeof onCheckoutClick === 'function') {
                var checkoutBtn = document.getElementById('gokwik-checkout-btn');
                if (checkoutBtn) onCheckoutClick(checkoutBtn);
                else onCheckoutClick({ id: 'gokwik-checkout-btn' });
              } else {
                window.location.href = cartRoot + 'checkout';
              }
            }
            if (attempts >= maxAttempts) {
              clearInterval(interval);
              window.location.href = cartRoot + 'checkout';
            }
          }, 500);
        }

        clearCouponForBloodBooking();
        fetch(cartRoot + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function(clearRes) { return clearRes.ok ? Promise.resolve() : Promise.reject(new Error('Clear failed')); })
          .then(function() {
            if (!variantId) {
              openCheckout();
              return;
            }
            restoreSubmitButtonFromCartClose();
            var addParams = new URLSearchParams({ id: String(variantId), quantity: '1' });
            lineItemAttributes.forEach(function(attr) {
              addParams.append('properties[' + attr.key + ']', attr.value);
            });
            var formBody = addParams.toString();
            return fetch(cartRoot + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
              body: formBody
            });
          })
          .then(function(addRes) {
            if (!variantId) return;
            if (!addRes || !addRes.ok) return addRes ? addRes.json().then(function(d) { throw new Error(d.description || 'Add to cart failed'); }) : Promise.resolve();
            return addRes.json();
          })
          .then(function() {
            return fetch(cartRoot + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
              body: 'discount='
            }).then(function(updateRes) { return updateRes.ok ? updateRes.json() : Promise.resolve(); }).catch(function() { return null; });
          })
          .then(function() {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            openCheckout();
          })
          .catch(function(err) {
            console.error('Blood booking cart flow:', err);
            openCheckout();
            restoreSubmitButtonFromCartClose();
          });
    })();
  });
})();

(function() {
  // Resolute payment API after GoKwik checkout success (blood slot booking only)
  var BLOOD_BOOKING_SUCCESS_FLAG = 'blood_booking_success';

  var SUCCESS_URL_PARAM = 'booking_success';

  function setSuccessUrlParam() {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get(SUCCESS_URL_PARAM) === '1') return;
    url.searchParams.set(SUCCESS_URL_PARAM, '1');
    window.history.replaceState({}, '', url.pathname + url.search);
  }

  function showBloodBookingSuccessState() {
    var formContainer = document.querySelector('.blood-slot-booking-form-container');
    var submitContainer = document.querySelector('.blood-slot-booking-submit-container');
    var noteContainer = document.querySelector('.blood-slot-booking-note-container');
    var successContainer = document.querySelector('.blood-slot-booking-success-container');
    var alreadyBookedContainer = document.querySelector('.blood-slot-booking-already-booked-container');
    var headerTitle = document.querySelector('.blood-slot-booking-header-title');
    var headerDescription = document.querySelector('.blood-slot-booking-header-description');
    if (formContainer) formContainer.style.display = 'none';
    if (submitContainer) submitContainer.style.display = 'none';
    if (noteContainer) noteContainer.style.display = 'none';
    if (headerTitle) headerTitle.style.display = 'none';
    if (headerDescription) headerDescription.style.display = 'none';
    if (alreadyBookedContainer) alreadyBookedContainer.style.display = 'none';
    if (successContainer) successContainer.style.display = 'flex';
    setSuccessUrlParam();
  }

  function hasSuccessUrlParam() {
    var p = new URLSearchParams(window.location.search);
    return p.get(SUCCESS_URL_PARAM) === '1' || p.get('blood_booking_success') === '1';
  }

  function showSuccessIfFlagPresent() {
    var fromStorage = false;
    try {
      fromStorage = sessionStorage.getItem(BLOOD_BOOKING_SUCCESS_FLAG) === '1';
    } catch (e) {}
    var fromUrl = hasSuccessUrlParam();
    if (fromStorage || fromUrl) {
      showBloodBookingSuccessState();
      try { sessionStorage.removeItem(BLOOD_BOOKING_SUCCESS_FLAG); } catch (e) {}
    }
  }

  window.bloodBookingShowSuccessState = showBloodBookingSuccessState;

  function triggerResolutePaymentApi(payload) {
    var pending = sessionStorage.getItem('resolute_payment_pending');
    if (!pending) return;
    try { sessionStorage.removeItem('resolute_payment_pending'); } catch (e) {}
    showBloodBookingSuccessState();
    try { sessionStorage.setItem(BLOOD_BOOKING_SUCCESS_FLAG, '1'); } catch (e) {}
    try { localStorage.removeItem('blood_slot_booking_form'); } catch (e) {}
  }
  function clearCartOnCheckoutClose() {
    var pending = null;
    try { pending = sessionStorage.getItem('resolute_payment_pending'); } catch (e) {}
    if (!pending) return;
    try { sessionStorage.removeItem('resolute_payment_pending'); } catch (e) {}
    var cartRoot = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    fetch(cartRoot + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function(res) { if (res.ok) document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); })
      .catch(function() {});
    if (typeof window.bloodBookingRestoreSubmitButton === 'function') window.bloodBookingRestoreSubmitButton();
  }

  function attachResolutePaymentListeners() {
    if (window.gokwikSdk && typeof window.gokwikSdk.on === 'function') {
      window.gokwikSdk.on('order_create_success', triggerResolutePaymentApi);
      window.gokwikSdk.on('modal_closed', clearCartOnCheckoutClose);
    }
  }
  if (window.gokwikSdk) {
    attachResolutePaymentListeners();
  } else {
    window.addEventListener('gokwikLoaded', attachResolutePaymentListeners);
  }
  window.addEventListener('message', function(e) {
    if (e.data === 'order_create_success' || (e.data && e.data.type === 'kp_order_success')) {
      triggerResolutePaymentApi(e.data);
    }
  });

  showSuccessIfFlagPresent();

  // When user clicks browser Back from orders page, page may be restored from bfcache
  // without re-running scripts; pageshow fires and we re-check the flag to show success.
  window.addEventListener('pageshow', function(e) {
    showSuccessIfFlagPresent();
  });
})();

(function() {
  // Google Places custom dropdown autocomplete for blood booking address
  var apiKey = window.BLOOD_GOOGLE_PLACES_API_KEY || '';
  if (!apiKey) return;

  function initBloodAddressAutocomplete() {
    var addressInput = document.getElementById('blood-address');
    if (!addressInput) return;

    if (!window.google || !google.maps || !google.maps.places || !google.maps.places.AutocompleteService) {
      return;
    }

    var formGroup = addressInput.parentNode;
    if (!formGroup) return;

    // Prevent multiple initializations
    if (formGroup.querySelector('.blood-address-autocomplete')) return;

    var dropdown = document.createElement('div');
    dropdown.className = 'blood-address-autocomplete';
    dropdown.setAttribute('role', 'listbox');
    formGroup.appendChild(dropdown);

    var service = new google.maps.places.AutocompleteService();
    var placesService = new google.maps.places.PlacesService(document.createElement('div'));
    var debounceTimer = null;

    function clearDropdown() {
      dropdown.innerHTML = '';
      dropdown.style.display = 'none';
    }

    function openLocationMapModal() {
      clearDropdown();
      if (!window.google || !google.maps) return;

      var geocoder = new google.maps.Geocoder();
      var modalTemplate = document.getElementById('blood-location-modal-template');
      if (!modalTemplate || !modalTemplate.content || !modalTemplate.content.firstElementChild) return;
      var overlay = modalTemplate.content.firstElementChild.cloneNode(true);
      var modal = overlay.querySelector('.blood-location-modal');
      if (!modal) return;
      document.body.appendChild(overlay);
      document.body.classList.add('blood-location-modal-open');

      var mapEl = document.getElementById('blood-location-map-canvas');
      var confirmBtn = document.getElementById('blood-location-confirm');
      var useCurrentBtn = document.getElementById('blood-location-use-current');
      var searchInput = document.getElementById('blood-location-search');
      var searchClear = document.getElementById('blood-location-search-clear');
      var selectedRow = document.getElementById('blood-location-selected-row');
      var selectedName = document.getElementById('blood-location-selected-name');
      var selectedAddress = document.getElementById('blood-location-selected-address');
      var selectedPlaceholder = document.getElementById('blood-location-selected-placeholder');
      var pinTooltip = document.getElementById('blood-location-pin-tooltip');
      var useCurrentBtnText = useCurrentBtn ? useCurrentBtn.querySelector('.blood-location-modal__use-current-text') : null;

      function setUseCurrentButtonLabel(text) {
        if (useCurrentBtnText) useCurrentBtnText.textContent = text;
      }

      var greenPinIcon = {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z',
        fillColor: '#000',
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 1.8,
        anchor: new google.maps.Point(12, 24)
      };

      var map = new google.maps.Map(mapEl, {
        center: { lat: 20.5937, lng: 78.9629 },
        zoom: 5,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        disableDefaultUI: true,
        draggable: true,
        gestureHandling: 'greedy'
      });

      var marker = null;
      var geocodeDebounceTimer = null;

      function updateSelectedLocation(formattedAddress, locationName) {
        var hasAddress = !!(formattedAddress && formattedAddress.trim());
        if (selectedPlaceholder) selectedPlaceholder.style.display = hasAddress ? 'none' : 'block';
        if (selectedRow) selectedRow.style.display = hasAddress ? 'flex' : 'none';
        if (selectedName) selectedName.textContent = locationName || '';
        if (selectedAddress) {
          selectedAddress.textContent = formattedAddress || '';
          selectedAddress.style.display = hasAddress ? 'block' : 'none';
        }
      }
      updateSelectedLocation('', '');

      function reverseGeocodeAndUpdate(pos) {
        geocoder.geocode(
          { location: { lat: pos.lat(), lng: pos.lng() } },
          function(results, status) {
            if (!results || !results.length || (google.maps.GeocoderStatus && status !== google.maps.GeocoderStatus.OK)) {
              updateSelectedLocation('', '');
              return;
            }
            var place = results[0];
            var addr = place.formatted_address || '';
            var name = '';
            if (place.address_components) {
              for (var i = 0; i < place.address_components.length; i++) {
                var c = place.address_components[i];
                if (c.types.indexOf('sublocality') !== -1 || c.types.indexOf('sublocality_level_1') !== -1) {
                  name = c.long_name || c.short_name || '';
                  break;
                }
                if (c.types.indexOf('locality') !== -1) {
                  name = name || (c.long_name || c.short_name || '');
                }
              }
              if (!name && place.address_components.length) {
                name = place.address_components[0].long_name || place.address_components[0].short_name || '';
              }
            }
            updateSelectedLocation(addr, name || addr.split(',')[0] || '');
          }
        );
      }

      function onMarkerPositionChange() {
        if (!marker) return;
        var pos = marker.getPosition();
        if (!pos) return;
        if (geocodeDebounceTimer) clearTimeout(geocodeDebounceTimer);
        geocodeDebounceTimer = setTimeout(function() {
          reverseGeocodeAndUpdate(pos);
        }, 300);
      }

      function placeMarker(position) {
        if (marker) marker.setMap(null);
        marker = new google.maps.Marker({
          position: position,
          map: map,
          draggable: true,
          icon: greenPinIcon
        });
        confirmBtn.disabled = false;
        //if (pinTooltip) pinTooltip.classList.add('is-visible');
        marker.addListener('dragend', onMarkerPositionChange);
        onMarkerPositionChange();
      }

      map.addListener('click', function(e) {
        placeMarker(e.latLng);
      });

      if (searchInput && google.maps.places && google.maps.places.Autocomplete) {
        var autocomplete = new google.maps.places.Autocomplete(searchInput, {
          types: ['geocode'],
          componentRestrictions: { country: 'in' },
          fields: ['geometry', 'formatted_address', 'address_components']
        });
        autocomplete.addListener('place_changed', function() {
          var place = autocomplete.getPlace();
          if (!place || !place.geometry || !place.geometry.location) return;
          var loc = place.geometry.location;
          map.setCenter(loc);
          map.setZoom(15);
          placeMarker(loc);
          if (place.formatted_address) {
            var nm = '';
            if (place.address_components) {
              for (var j = 0; j < place.address_components.length; j++) {
                var comp = place.address_components[j];
                if (comp.types.indexOf('sublocality') !== -1 || comp.types.indexOf('sublocality_level_1') !== -1) {
                  nm = comp.long_name || comp.short_name || '';
                  break;
                }
                if (comp.types.indexOf('locality') !== -1) nm = nm || (comp.long_name || comp.short_name || '');
              }
            }
            updateSelectedLocation(place.formatted_address, nm || place.formatted_address.split(',')[0] || '');
          }
        });
      }

      searchInput.addEventListener('input', function() {
        if (searchClear) searchClear.classList.toggle('is-visible', searchInput.value.length > 0);
      });
      searchClear.addEventListener('click', function() {
        searchInput.value = '';
        if (searchClear) searchClear.classList.remove('is-visible');
        searchInput.focus();
      });

      function closeModal() {
        document.body.classList.remove('blood-location-modal-open');
        overlay.remove();
      }

      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeModal();
      });

      modal.querySelector('.blood-location-modal__close').addEventListener('click', closeModal);

      useCurrentBtn.addEventListener('click', function() {
        if (!navigator.geolocation) return;
        useCurrentBtn.disabled = true;
        setUseCurrentButtonLabel('Getting location...');
        navigator.geolocation.getCurrentPosition(
          function(position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            var pos = { lat: lat, lng: lng };
            map.setCenter(pos);
            map.setZoom(14);
            showInfoWindowOnNextGeocode = true;
            placeMarker(pos);
            useCurrentBtn.disabled = false;
            var selectedSection = document.querySelector('.blood-location-modal__selected');
            if (selectedSection) {
              setTimeout(function() { selectedSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 600);
            }
            setUseCurrentButtonLabel('Use current location');
          },
          function() {
            useCurrentBtn.disabled = false;
            setUseCurrentButtonLabel('Use current location');
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
        );
      });

      confirmBtn.addEventListener('click', function() {
        if (!marker) return;
        var pos = marker.getPosition();
        if (!pos) return;
        geocoder.geocode(
          { location: { lat: pos.lat(), lng: pos.lng() } },
          function(results, status) {
            if (!results || !results.length || (google.maps.GeocoderStatus && status !== google.maps.GeocoderStatus.OK)) {
              return;
            }
            var place = results[0];
            addressInput.setAttribute('data-blood-autocomplete-suppress', '1');
            addressInput.value = place.formatted_address || '';
            if (place.address_components && place.address_components.length) {
              fillAddressFromComponents(place.address_components);
            }
            var autocompleteEl = addressInput.parentNode && addressInput.parentNode.querySelector('.blood-address-autocomplete');
            if (autocompleteEl) {
              autocompleteEl.innerHTML = '';
              autocompleteEl.style.display = 'none';
            }
            try { addressInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
            closeModal();
            setTimeout(function() { addressInput.removeAttribute('data-blood-autocomplete-suppress'); }, 400);
          }
        );
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            var pos = { lat: lat, lng: lng };
            map.setCenter(pos);
            map.setZoom(14);
            showInfoWindowOnNextGeocode = true;
            placeMarker(pos);
            var selectedSection = document.querySelector('.blood-location-modal__selected');
            if (selectedSection) {
              setTimeout(function() { selectedSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 600);
            }
          },
          function() {},
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
        );
      }
    }

    function appendUseMyLocationRow() {
      var item = document.createElement('div');
      item.className = 'blood-address-autocomplete__item blood-address-autocomplete__item--location';
      item.setAttribute('role', 'option');
      item.setAttribute('aria-label', 'Use my current location');
      item.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg><span>Use my location</span>';
      item.addEventListener('mousedown', function(e) {
        e.preventDefault();
        openLocationMapModal();
      });
      dropdown.appendChild(item);
    }

    function fillAddressFromComponents(components) {
      if (!components || !components.length) return;

      var cityInput = document.getElementById('blood-city');
      var pincodeInput = document.getElementById('blood-pincode');

      var stateSelect = document.getElementById('blood-state');
      var stateDropdown = document.getElementById('blood-state-dropdown');
      var stateTrigger = document.getElementById('blood-state-trigger');
      var stateTriggerText = stateDropdown && stateDropdown.querySelector('.custom-dropdown__trigger-text');
      var stateOptionsList = document.getElementById('blood-state-list');
      var stateOptions = stateOptionsList ? stateOptionsList.querySelectorAll('.custom-dropdown__option') : [];

      // Prefer actual city (locality) over sublocality/sector.
      // Example: "Sector 24" often comes as sublocality_level_1, while "Gurugram"
      // comes as locality — we want "Gurugram" in the City field.
      var city = '';
      var cityLocality = '';
      var cityDistrict = '';
      var citySublocality = '';
      var state = '';
      var postalCode = '';

      components.forEach(function(c) {
        if (!c || !c.types) return;
        if (c.types.indexOf('locality') !== -1) {
          cityLocality = cityLocality || (c.long_name || c.short_name || '');
        }
        // Some geocodes may provide city as postal_town (mainly non-India, but safe fallback)
        if (c.types.indexOf('postal_town') !== -1) {
          cityLocality = cityLocality || (c.long_name || c.short_name || '');
        }
        if (c.types.indexOf('administrative_area_level_2') !== -1) {
          cityDistrict = cityDistrict || (c.long_name || c.short_name || '');
        }
        if (c.types.indexOf('sublocality_level_1') !== -1) {
          citySublocality = citySublocality || (c.long_name || c.short_name || '');
        }
        if (c.types.indexOf('administrative_area_level_1') !== -1) {
          state = c.long_name || c.short_name || '';
        }
        if (c.types.indexOf('postal_code') !== -1) {
          postalCode = c.long_name || c.short_name || '';
        }
      });

      city = (cityLocality || cityDistrict || citySublocality || '').trim();

      if (cityInput) {
        cityInput.value = city !== '' ? city : '';
        try { cityInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      }

      if (pincodeInput) {
        pincodeInput.value = postalCode !== '' ? postalCode : '';
        try { pincodeInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      }

      if (state && stateSelect && stateTrigger && stateTriggerText && stateOptionsList) {
        var normalizedState = state.toLowerCase();
        var matchedValue = '';

        stateOptions.forEach(function(opt) {
          var val = opt.getAttribute('data-value') || '';
          if (!matchedValue && val.toLowerCase() === normalizedState) {
            matchedValue = val;
          }
        });

        if (!matchedValue) {
          matchedValue = 'Other';
        }

        stateSelect.value = matchedValue;
        stateTriggerText.textContent = matchedValue;
        if (matchedValue) {
          stateTrigger.classList.remove('custom-dropdown__trigger--placeholder');
        } else {
          stateTrigger.classList.add('custom-dropdown__trigger--placeholder');
        }

        stateOptions.forEach(function(opt) {
          opt.classList.toggle('is-selected', opt.getAttribute('data-value') === matchedValue);
        });

        try { stateSelect.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
    }

    function handlePredictionSelect(prediction) {
      if (!prediction) return;

      addressInput.setAttribute('data-blood-autocomplete-suppress', '1');
      clearDropdown();
      addressInput.value = prediction.description || '';
      try {
        addressInput.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (err) {}
      setTimeout(function() { addressInput.removeAttribute('data-blood-autocomplete-suppress'); }, 400);

      if (!prediction.place_id || !placesService) return;

      placesService.getDetails(
        {
          placeId: prediction.place_id,
          fields: ['address_component']
        },
        function(place, status) {
          if (
            !place ||
            !place.address_components ||
            !window.google ||
            !google.maps ||
            !google.maps.places ||
            typeof google.maps.places.PlacesServiceStatus === 'undefined' ||
            status !== google.maps.places.PlacesServiceStatus.OK
          ) {
            return;
          }
          fillAddressFromComponents(place.address_components || []);
        }
      );
    }

    function showDropdownWithLocationOnly() {
      if (addressInput.getAttribute('data-blood-autocomplete-suppress')) return;
      dropdown.innerHTML = '';
      appendUseMyLocationRow();
      dropdown.style.display = 'block';
    }

    function renderPredictions(predictions) {
      if (addressInput.getAttribute('data-blood-autocomplete-suppress')) return;
      dropdown.innerHTML = '';
      if (!predictions || !predictions.length) {
        clearDropdown();
        return;
      }

      appendUseMyLocationRow();

      predictions.forEach(function(prediction) {
        var item = document.createElement('div');
        item.className = 'blood-address-autocomplete__item';
        item.setAttribute('role', 'option');
        item.textContent = prediction.description || '';

        item.addEventListener('mousedown', function(e) {
          // Use mousedown so click works before input blur hides dropdown
          e.preventDefault();
          handlePredictionSelect(prediction);
          clearDropdown();
        });

        dropdown.appendChild(item);
      });

      dropdown.style.display = 'block';
    }

    function fetchPredictions(query) {
      if (!query || query.length < 3) {
        clearDropdown();
        return;
      }

      service.getPlacePredictions(
        {
          input: query,
          componentRestrictions: { country: 'in' },
          types: ['geocode']
        },
        function(predictions, status) {
          if (
            !window.google ||
            !google.maps ||
            !google.maps.places ||
            typeof google.maps.places.PlacesServiceStatus === 'undefined' ||
            status !== google.maps.places.PlacesServiceStatus.OK
          ) {
            clearDropdown();
            return;
          }
          if (addressInput.getAttribute('data-blood-autocomplete-suppress')) return;
          renderPredictions(predictions || []);
        }
      );
    }

    addressInput.addEventListener('focus', function() {
      if (addressInput.getAttribute('data-blood-autocomplete-suppress')) return;
      var value = (addressInput.value || '').trim();
      if (value.length >= 3) {
        fetchPredictions(value);
      } else {
        showDropdownWithLocationOnly();
      }
    });

    addressInput.addEventListener('input', function() {
      var value = (addressInput.value || '').trim();
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      debounceTimer = setTimeout(function() {
        if (addressInput.getAttribute('data-blood-autocomplete-suppress')) return;
        if (value.length >= 3) {
          fetchPredictions(value);
        } else {
          showDropdownWithLocationOnly();
        }
      }, 200);
    });

    addressInput.addEventListener('blur', function() {
      // Delay hiding slightly so click/mousedown on items can fire
      setTimeout(clearDropdown, 150);
    });
  }

  function loadPlacesScript() {
    if (window.google && google.maps && google.maps.places && google.maps.places.AutocompleteService) {
      initBloodAddressAutocomplete();
      return;
    }

    var existingScript = document.querySelector('script[data-blood-places-autocomplete]');
    if (existingScript) {
      existingScript.addEventListener('load', initBloodAddressAutocomplete);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=places';
    script.async = true;
    script.defer = true;
    script.setAttribute('data-blood-places-autocomplete', 'true');
    script.onload = initBloodAddressAutocomplete;
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPlacesScript);
  } else {
    loadPlacesScript();
  }
})();

(function() {
  var STORAGE_KEY = 'blood_slot_booking_form';

  function getFormData() {
    var addressEl = document.getElementById('blood-address');
    var flatEl = document.getElementById('blood-flat');
    var landmarkEl = document.getElementById('blood-landmark');
    var emailEl = document.getElementById('blood-email');
    var cityEl = document.getElementById('blood-city');
    var stateEl = document.getElementById('blood-state');
    var pincodeEl = document.getElementById('blood-pincode');
    var dateEl = document.getElementById('blood-date');
    var timeEl = document.getElementById('blood-time');
    return {
      address: (addressEl && addressEl.value) || '',
      flat: (flatEl && flatEl.value) || '',
      landmark: (landmarkEl && landmarkEl.value) || '',
      email: (emailEl && emailEl.value) || '',
      city: (cityEl && cityEl.value) || '',
      state: (stateEl && stateEl.value) || '',
      pincode: (pincodeEl && pincodeEl.value) || '',
      date: (dateEl && dateEl.value) || '',
      time: (timeEl && timeEl.value) || ''
    };
  }

  function saveFormData() {
    try {
      var data = getFormData();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function formatDateDisplay(dateStr) {
    if (!dateStr || dateStr.length < 10) return '';
  
    var parts = dateStr.split('-');
    if (parts.length !== 3) return '';
  
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10); // DO NOT subtract 1
    var d = parseInt(parts[2], 10);
  
    if (isNaN(y) || isNaN(m) || isNaN(d) || m < 1 || m > 12) return '';
  
    // Add leading zero if needed
    var day = d < 10 ? '0' + d : d;
    var month = m < 10 ? '0' + m : m;
  
    return day + '-' + month + '-' + y;
  }

  function restoreFormData() {
    var form = document.querySelector('.blood-slot-booking-form');
    if (!form) return;
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return;

      var addressEl = document.getElementById('blood-address');
      var flatEl = document.getElementById('blood-flat');
      var landmarkEl = document.getElementById('blood-landmark');
      var emailEl = document.getElementById('blood-email');
      var cityEl = document.getElementById('blood-city');
      var stateEl = document.getElementById('blood-state');
      var pincodeEl = document.getElementById('blood-pincode');
      var dateEl = document.getElementById('blood-date');
      var timeEl = document.getElementById('blood-time');

      if (addressEl && data.address != null) addressEl.value = data.address;
      if (flatEl && data.flat != null) flatEl.value = data.flat;
      if (landmarkEl && data.landmark != null) landmarkEl.value = data.landmark;
      if (emailEl && data.email != null) emailEl.value = data.email;
      if (cityEl && data.city != null) cityEl.value = data.city;
      if (pincodeEl && data.pincode != null) pincodeEl.value = data.pincode;

      if (stateEl && data.state != null && data.state !== '') {
        stateEl.value = data.state;
        try { stateEl.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }

      if (dateEl && data.date != null && data.date !== '') {
        dateEl.value = data.date;
        var dateTriggerText = document.querySelector('#blood-date-picker .custom-date-picker__trigger-text');
        var dateTrigger = document.getElementById('blood-date-trigger');
        if (dateTriggerText) dateTriggerText.textContent = formatDateDisplay(data.date);
        if (dateTrigger) dateTrigger.classList.remove('custom-date-picker__trigger--placeholder');
        if (window.bloodBookingFilterTimeSlots) window.bloodBookingFilterTimeSlots(data.date);
      }

      if (timeEl && data.time != null && data.time !== '') {
        timeEl.value = data.time;
        var timeTriggerText = document.querySelector('#blood-time-dropdown .custom-time-dropdown__trigger-text');
        var timeTrigger = document.getElementById('blood-time-trigger');
        if (timeTriggerText) timeTriggerText.textContent = data.time;
        if (timeTrigger) timeTrigger.classList.remove('custom-time-dropdown__trigger--placeholder');
      }

      form.dispatchEvent(new Event('input', { bubbles: true }));
      form.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  function init() {
    var form = document.querySelector('.blood-slot-booking-form');
    if (!form) return;

    restoreFormData();

    var saveTimeout = null;
    function scheduleSave() {
      if (saveTimeout) clearTimeout(saveTimeout);
      saveTimeout = setTimeout(saveFormData, 300);
    }

    form.addEventListener('input', scheduleSave);
    form.addEventListener('change', scheduleSave);
    form.addEventListener('blur', scheduleSave, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
